module.exports = {"520602001":"市中","520602002":"环北","520602003":"河西","520602005":"灯塔","520602006":"川硐","520602101":"坝黄镇","520602102":"云场坪镇","520602103":"漾头镇","520602200":"桐木坪乡","520602201":"滑石乡","520602202":"和平乡","520602203":"瓦屋乡","520602204":"六龙山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520602.json
// module id = 2304
// module chunks = 0